import { Flex, Tag } from '@lokalise/louis';

import classes from './styles.module.css';

interface NavItemContentProps {
    label: string;
    badge?: number;
    novel?: string;
}
const NavItemContents = ({ label, badge, novel }: NavItemContentProps) => (
    <Flex gap={1}>
        <div>
            <span>{label}</span>
            {!!badge && (
                <div className={classes.badge} role="status" aria-label={`${badge} items requiring attention`}>
                    {badge > 9 ? '9+' : badge}
                </div>
            )}
        </div>
        {!!novel && <Tag className={classes.tag}>{novel}</Tag>}
    </Flex>
);

export default NavItemContents;
